// extracted by mini-css-extract-plugin
export default {"overlay":"dx-z","bodyOpen":"ex-z","content":"fx-z","header":"gx-z","close":"hx-z","closeNoHeading":"ix-z"};